import React, { useEffect, useState } from "react";
import { collection, query, orderBy, limit, getDocs } from "firebase/firestore";
import { db } from "../firebase.config";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrophy } from "@fortawesome/free-solid-svg-icons";

const EventLeaderboard = () => {
  const [topEventUsers, setTopEventUsers] = useState([]);

  useEffect(() => {
    const fetchTopEventUsers = async () => {
      try {
        const eventQuery = query(
          collection(db, "users"),
          orderBy("eventCount", "desc"),
          limit(5)
        );

        const eventSnapshot = await getDocs(eventQuery);
        const topUsers = eventSnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setTopEventUsers(topUsers);
      } catch (error) {
        console.error("Error fetching top event users:", error);
      }
    };

    fetchTopEventUsers();
  }, []);

  return (
    <div className="bg-black p-6 rounded-lg shadow-md w-80">
      <h3 className="text-2xl font-bold text-center mb-4 bg-gradient-to-r from-green-400 to-blue-500 text-transparent bg-clip-text">
        Events Leaderboard
      </h3>
      <p className="text-sm text-center mb-6 text-gray-400">
        Compete and climb the social Crush on the leaderboard to see who's
        leading the pack in the community
      </p>
      <div className="space-y-3">
        {topEventUsers.map((user, index) => (
          <div
            key={user.id}
            className={`flex items-center justify-between p-3 rounded-lg ${
              index === 0
                ? "bg-gradient-to-r from-green-400 to-blue-500"
                : "bg-gray-800"
            }`}
          >
            <div className="flex items-center space-x-3">
              <span
                className={`font-bold ${
                  index === 0 ? "text-black" : "text-white"
                }`}
              >
                #{index + 1}
              </span>
              <img
                src={user.profileImageUrl || "https://via.placeholder.com/40"}
                alt={user.name}
                className="w-10 h-10 rounded-full"
              />
              <span
                className={`font-semibold ${
                  index === 0 ? "text-lg text-black" : "text-white"
                }`}
              >
                {user.name}
              </span>
            </div>
            <div className="flex items-center space-x-1">
              <FontAwesomeIcon
                icon={faTrophy}
                className={index === 0 ? "text-yellow-400" : "text-gray-400"}
              />
              <span className={index === 0 ? "text-black" : "text-white"}>
                {user.eventCount}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default EventLeaderboard;
